module.exports = __webpack_public_path__ + "img/png_xiaomalan.82c3d47b.png";